var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"results__list"},_vm._l((_vm.catalog),function(item,i){return _c('li',{key:((item.slug) + "-" + i),staticClass:"results__list__item"},[_c('CatalogCard',{attrs:{"content":item},on:{"selected":_vm.select}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }